// extracted by mini-css-extract-plugin
export default {"page_wrapper":"pricing_page_wrapper__17L0a"};